/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { MultipartAssetUploadCompletion } from './MultipartAssetUploadCompletion';
import {
    MultipartAssetUploadCompletionFromJSON,
    MultipartAssetUploadCompletionFromJSONTyped,
    MultipartAssetUploadCompletionToJSON,
    instanceOfMultipartAssetUploadCompletion,
} from './MultipartAssetUploadCompletion';

/**
 * 
 * @export
 * @interface Multipart
 */
export interface Multipart {
    /**
     * 
     * @type {MultipartAssetUploadCompletion}
     * @memberof Multipart
     */
    multipart: MultipartAssetUploadCompletion;
}


/**
 * Check if a given object implements the Multipart interface.
 */
export function instanceOfMultipart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "multipart" in value;
    return isInstance;
}

export function MultipartFromJSON(json: any): Multipart {
    return MultipartFromJSONTyped(json, false);
}

export function MultipartFromJSONTyped(json: any, ignoreDiscriminator: boolean): Multipart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'multipart': MultipartAssetUploadCompletionFromJSON(json['multipart']),
    };
}

export function MultipartToJSON(value?: Multipart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'multipart': MultipartAssetUploadCompletionToJSON(value.multipart),
    };
}

